import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=1d5126e6&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=ts"
export * from "./Registro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5126e6",
  null
  
)

export default component.exports